import React from 'react';
import s from "./styles.module.scss";
import logo from "../../assets/logo.svg";

const PageHeader = ({title, description, step}) => {
  return (
    <div className={s.pageHeader}>
      <img src={logo} alt="Logo" className={s.logo}/>

      <h1 className={s.pageTitle}>{title}</h1>

      {description &&
        <p className={s.pageSubtitle}>
          {description}
        </p>
      }

      {step &&
        <div className={s.stepIndicator}>
          {step}
        </div>
      }
    </div>
  );
};

export default PageHeader;